import React from 'react';
import { Teacher } from './TeacherCard';
import DescriptionSection from './DescriptionSection';
import TeacherSelectionSection from './TeacherSelectionSection';
import CalendarSection from './CalendarSection';

interface ProductInfoProps {
    productName: string | null | undefined;
    descriptionExpanded: boolean;
    setDescriptionExpanded: (expanded: boolean) => void;
    teacherExpanded: boolean;
    setTeacherExpanded: (expanded: boolean) => void;
    calendarExpanded: boolean;
    setCalendarExpanded: (expanded: boolean) => void;
    teachers: Teacher[];
    selectedTeacher: Teacher | null;
    setSelectedTeacher: (teacher: Teacher) => void;
    selectedDate: Date | null;
    setSelectedDate: (date: Date | null) => void;
    selectedTime: Date | null;
    setSelectedTime: (time: Date) => void;
    disabled?: boolean;
}

const ProductInfo: React.FC<ProductInfoProps> = ({
    productName,
    descriptionExpanded,
    setDescriptionExpanded,
    teacherExpanded,
    setTeacherExpanded,
    calendarExpanded,
    setCalendarExpanded,
    teachers,
    selectedTeacher,
    setSelectedTeacher,
    selectedDate,
    setSelectedDate,
    selectedTime, 
    setSelectedTime,
    disabled = false
}) => {
    return (
        <div className="product-details">
            <h1 className="product-title">{productName || "Loading..."}</h1>
            
            <DescriptionSection
                expanded={descriptionExpanded}
                setExpanded={setDescriptionExpanded}
                disabled={disabled}
            />
            
            <TeacherSelectionSection
                expanded={teacherExpanded}
                setExpanded={setTeacherExpanded}
                teachers={teachers}
                selectedTeacher={selectedTeacher}
                setSelectedTeacher={setSelectedTeacher}
                disabled={disabled}
            />
            
            <CalendarSection
                expanded={calendarExpanded}
                setExpanded={setCalendarExpanded}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedTime={selectedTime}
                setSelectedTime={setSelectedTime}
                disabled={disabled}
            />
        </div>
    );
};

export default ProductInfo;